import React from 'react';
export function Hero() {
  return <section className="w-full flex flex-col items-center" data-id="element-52">
      <div className="w-full" data-id="element-53">
        <img src="https://cdn.magicpatterns.com/uploads/niZDmPuENQZg5qxkhPjBZC/banner_original.png" alt="Pueblo Barber Banner" className="w-full h-auto object-contain" data-id="element-54" />
      </div>
      <div className="max-w-4xl mx-auto px-4 py-16 text-center flex flex-col items-center" data-id="element-55">
        <h1 className="font-display text-5xl md:text-7xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-56">
          Pueblo Barber{' '}
          <span className="text-gold block mt-2" data-id="element-57">— Sé Tu Mejor Versión</span>
        </h1>
        <p className="text-muted text-lg md:text-xl mb-10 max-w-2xl" data-id="element-58">
          Barbería profesional & Escuela de Barbería en C.M Ramírez 1528
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-59">
          <a href="https://book.weibook.co/branch/pueblo-barber-sede-1" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-background font-bold py-4 px-8 rounded uppercase tracking-wider transition-colors text-center" data-id="element-60">
            Reserva tu Cita
          </a>
          <a href="#cursos" className="border-2 border-gold text-gold hover:bg-gold hover:text-background font-bold py-4 px-8 rounded uppercase tracking-wider transition-colors text-center" data-id="element-61">
            Ver Cursos 2026
          </a>
        </div>
      </div>
    </section>;
}